/* ============================================================
   Service Locator — assets/service-locator.js
   Extracted verbatim from sections/store-locator.liquid.
   serviceDatabase loaded dynamically from service-centers.json
   via window.serviceLocatorDataUrl (set in store-locator.liquid).
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     Core initialisation — receives full serviceDatabase loaded
     from service-centers.json
  ---------------------------------------------------------- */
  function initializeServiceLocator(serviceDatabase) {

    // Official India Bounds — required for legal compliance
    const indiaBounds = L.latLngBounds(
      L.latLng(6.5,  68.1),
      L.latLng(37.6, 97.4)
    );

    const isMobile  = window.innerWidth < 768;
    const startZoom = isMobile ? 4 : 5;

    var map = L.map('map', {
      center: [22.5937, 78.9629],
      zoom: startZoom,
      minZoom: isMobile ? 4 : 5,
      maxZoom: 12,
      maxBounds: indiaBounds,
      maxBoundsViscosity: 1.0,
      attributionControl: false
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

    // Load official India GeoJSON boundary overlay
    fetch('https://raw.githubusercontent.com/datameet/maps/master/Country/india-composite.json')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        L.geoJSON(data, {
          style: { color: '#333', weight: 2, fillOpacity: 0, dashArray: '3' }
        }).addTo(map);
      })
      .catch(function () {
        // boundary loaded internally
      });

    // Render all service-centre dots
    var bgIcon     = L.divIcon({ className: 'bg-marker-dot', iconSize: [12, 12] });
    var allMarkers = L.layerGroup().addTo(map);
    Object.values(serviceDatabase).forEach(function (loc) {
      L.marker([loc.lat, loc.lng], { icon: bgIcon }).addTo(allMarkers);
    });

    var activeMarker = null;

    /* ----------------------------------------------------------
       Haversine distance (km)
    ---------------------------------------------------------- */
    function getDistance(lat1, lon1, lat2, lon2) {
      var R    = 6371;
      var dLat = (lat2 - lat1) * Math.PI / 180;
      var dLon = (lon2 - lon1) * Math.PI / 180;
      var a    = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                 Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                 Math.sin(dLon / 2) * Math.sin(dLon / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    /* ----------------------------------------------------------
       Public search function — called by the button's onclick
    ---------------------------------------------------------- */
    window.searchPincode = async function () {
      var pin = document.getElementById('pinInput').value.trim();
      if (!/^\d{6}$/.test(pin)) {
        alert('Please enter a valid 6-digit PIN');
        return;
      }

      var data      = serviceDatabase[pin];
      var isNearest = false;

      if (!data) {
        isNearest = true;
        try {
          var geoRes  = await fetch(
            'https://nominatim.openstreetmap.org/search?format=json&postalcode=' +
            pin + '&countrycodes=in'
          );
          var geoData = await geoRes.json();

          if (geoData && geoData.length > 0) {
            var userLat = parseFloat(geoData[0].lat);
            var userLng = parseFloat(geoData[0].lon);
            var minKm   = Infinity;
            var nearest = null;

            Object.values(serviceDatabase).forEach(function (loc) {
              var km = getDistance(userLat, userLng, loc.lat, loc.lng);
              if (km < minKm) { minKm = km; nearest = loc; }
            });
            data = nearest;
          } else {
            // Fallback: nearest PIN code by numeric proximity
            var minDiff = Infinity;
            Object.keys(serviceDatabase).forEach(function (key) {
              var diff = Math.abs(parseInt(pin, 10) - parseInt(key, 10));
              if (diff < minDiff) { minDiff = diff; data = serviceDatabase[key]; }
            });
          }
        } catch (e) {
          console.error('Geocoding error:', e);
        }
      }

      if (data) {
        if (activeMarker) { map.removeLayer(activeMarker); }
        activeMarker = L.marker([data.lat, data.lng])
          .addTo(map)
          .bindPopup('<b>' + data.name + '</b>')
          .openPopup();
        map.flyTo([data.lat, data.lng], 10);

        document.getElementById('coverageStatic').style.display = 'none';
        document.getElementById('resultCard').style.display     = 'block';
        document.getElementById('cityName').innerText           = data.name;
        document.getElementById('cityDetails').innerHTML        =
          '<strong>' + (data.asc || 'Authorized Service Center') + '</strong>' +
          '<br>' + (data.address || data.desc);
        document.getElementById('nearestLabel').style.display   = isNearest ? 'block' : 'none';
        document.getElementById('directionBtn').href            =
          'https://www.google.com/maps/dir/?api=1&destination=' +
          data.lat + ',' + data.lng + '&travelmode=driving';
      } else {
        alert('Could not locate any nearby service centers.');
      }
    };
  }

  /* ----------------------------------------------------------
     Bootstrap — fetch service-centers.json then initialise
  ---------------------------------------------------------- */
  function loadAndInit() {
    var url = window.serviceLocatorDataUrl;
    if (!url) {
      console.error('Service locator: window.serviceLocatorDataUrl not set');
      return;
    }
    fetch(url)
      .then(function (res) {
        if (!res.ok) { throw new Error('HTTP ' + res.status); }
        return res.json();
      })
      .then(function (serviceDatabase) {
        initializeServiceLocator(serviceDatabase);
      })
      .catch(function (err) {
        console.error('Service locator: failed to load service-centers.json —', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadAndInit);
  } else {
    loadAndInit();
  }

})();
